import { Component, ViewEncapsulation } from '@angular/core';
import { MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'copo-snackbar-submit-claim',
	templateUrl: './snackbar-submit-claim.component.html',
	styleUrl: './snackbar-submit-claim.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [TranslateModule]
})
export class SnackbarSubmitClaimComponent {
	constructor(
		private readonly snackBarRef: MatSnackBarRef<SnackbarSubmitClaimComponent>
	) {}

	dismiss() {
		this.snackBarRef.dismiss();
	}
}
